import type { Token } from "@auto-pools/core";

function usesScaledPoolUnits(tokens: readonly Pick<Token, "usesScaledUiAmount">[]) {
  return tokens.some((token) => token.usesScaledUiAmount === true);
}

export function ScaledPoolUnitsNote({ tokens }: { tokens: readonly Token[] }) {
  if (!usesScaledPoolUnits(tokens)) return null;
  return (
    <p className="scaled-pool-units-note">
      <strong>Pool units (unscaled).</strong> Token amounts, pair prices and stops exclude the
      wallet display multiplier. Wallet amounts may differ.
    </p>
  );
}
